import { Paragraph20, Paragraph30 } from '@squareup/dex-ui-shared-base';
import { breakHtmlForSlash } from '@squareup/dex-utils-text';
import clsx from 'clsx';
import parse from 'html-react-parser';
import React, { FC, useMemo } from 'react';

import { HttpMethods, HttpMethodString } from '../HttpMethodString';

import styles from './api-route.module.css';

interface ApiRouteProps {
  readonly httpMethod: HttpMethods;
  readonly isDeprecated: boolean;
  readonly path: string;
  readonly testId?: string;
}

const strings = {
  deprecated: 'DEPRECATED',
};

const ApiRoute: FC<ApiRouteProps> = ({
  httpMethod,
  isDeprecated,
  path,
  testId = 'api-route',
}) => {
  const method = isDeprecated ? (
    <Paragraph30
      weight="semi-bold"
      as="span"
      className={clsx(styles['api-route__method'], styles.deprecated)}
    >
      {strings.deprecated}
    </Paragraph30>
  ) : (
    <HttpMethodString
      as="span"
      httpMethod={httpMethod}
      className={styles['api-route__method']}
    />
  );

  const formattedPath = useMemo(() => parse(breakHtmlForSlash(path)), [path]);

  return (
    <Paragraph20 as="span" className={styles['api-route']} data-testid={testId}>
      {method}
      {formattedPath}
    </Paragraph20>
  );
};

export { ApiRoute };
